import React from "react";
import { RiMessengerLine, RiFacebookCircleLine } from "react-icons/ri";
import { FiInstagram } from "react-icons/fi";
import { AiOutlineShopping } from "react-icons/ai";

const Header = () => {
  return (
    <nav className="navbar">
      <div className="navbar-start flex gap-2 text-white">
        <RiMessengerLine className="text-xl" />
        <FiInstagram className="text-xl" />
        <RiFacebookCircleLine className="text-xl" />
      </div>
      <div className="navbar-center">
        <h1 className="text-white">LOUVRE</h1>
      </div>
      <div className="navbar-end text-white">
        <AiOutlineShopping className="text-xl" />
      </div>
    </nav>
  );
};

export default Header;
